import { Poster, VideoItemData, NextPageInfo, SeasonInfo, PlayListUiType, TagLabel, VideoType } from '@/types/common';
import {
  PlayUrlResponse,
  HandledVideoItemData,
  HandledCoverItemData,
  AutoPlayVideoData,
  HandledSeasonItem,
  SeasonType,
  GroupListItem,
  OptionListItem,
  playListStyleType,
  OptionType,
  NextVidInfoItem,
} from '@/types/playDetail';
import { PosterLabelType, markLabelPositionToKey, HistorySaveItem } from '@/types/history';
import { GROUP_SIZE, PlayDetailPageText } from '../constants/playPage';
const {
  playNow,
  containuePlay,
  episodeAndRelateVideo,
  allText,
  allEpisode,
  updateToEpisode,
  episodeList,
  relatedEpisodes,
  episodeNumToNum,
  episodeNum,
  more,
} = PlayDetailPageText;

export const CIDCheck = /^[a-z0-9A-Z]{15}$/;
export const VIDCheck = /^[a-z0-9A-Z]{11}$/;

// 处理剧集列表
export const handleVideoList = (videoList: VideoItemData[]): HandledVideoItemData[] => {
  return videoList.map((item) => {
    const {
      cid = '',
      vid = '',
      vid_type: videoType,
      title = '',
      poster: {
        horizontal_info: horizontalInfo,
        vertical_info: verticalInfo,
        main_title: mainTitle = '',
        mark_label_list: markLabelList,
      } = {},
      duration = '',
      episode_id: episodeId,
      skip_head_begin: skipHeadBegin,
      is_trailer: isTrailer,
      pay_preview: payPreview,
    } = item;
    const { pure_img_op_url: pureImgOpUrlHz = '', img_url: imgUrlHz = '' } = horizontalInfo || {};
    const { pure_img_op_url: pureImgOpUrlVt = '', img_url: imgUrlVt = '' } = verticalInfo || {};
    const cornerLabels = (markLabelList || []).map((tag) => {
      const { text, position, url } = tag;
      const type = url ? PosterLabelType.IMG : PosterLabelType.TEXT;
      const content = url || text;
      const positionKey = markLabelPositionToKey[position];
      return {
        position: positionKey,
        content,
        type,
      };
    });
    return {
      cid,
      vid,
      videoType,
      episodeId,
      cover: {
        horizontal: pureImgOpUrlHz,
        vertical: pureImgOpUrlVt,
      },
      fallbackCover: {
        horizontal: imgUrlHz,
        vertical: imgUrlVt,
      },
      cornerLabels,
      isTrailer,
      payPreview,
      title: title || mainTitle,
      duration,
      videoPlayTime: 0,
      videoTotalTime: Number(duration),
      skipHeadBegin,
    };
  });
};

// 处理cid海报封面
export const handleCoverList = (coverList: Poster[]): HandledCoverItemData[] => {
  return coverList.map((item) => {
    const {
      cid = '',
      vid = '',
      pid = '',

      art_title_img: artTitleImg = '',
      main_title: mainTitle = '',
      mark_label_list: markLabelList,
      vertical_info: verticalInfo,
      horizontal_info: horizontalInfo,
      report_data: reportData,
    } = item;
    const { pure_img_op_url: pureImgOpUrlVt = '', img_url: imgUrlVt = '' } = verticalInfo || {};
    const { pure_img_op_url: pureImgOpUrlHz = '', img_url: imgUrlHz = '' } = horizontalInfo || {};
    const { report_params: reportParams = '' } = reportData || {};
    const cornerLabels = (markLabelList || []).map((tag) => {
      const { text, position, url } = tag;
      const type = url ? PosterLabelType.IMG : PosterLabelType.TEXT;
      const content = url || text;
      const positionKey = markLabelPositionToKey[position];
      return {
        position: positionKey,
        content,
        type,
      };
    });
    return {
      cid,
      vid,
      pid,
      artTitleImg,
      mainTitle,
      cornerLabels,
      cover: {
        horizontal: pureImgOpUrlHz,
        vertical: pureImgOpUrlVt,
      },
      fallbackCover: {
        horizontal: imgUrlHz || '',
        vertical: imgUrlVt || '',
      },
      reportParams,
    };
  });
};

export const handleDefSeasonItem = (season: SeasonInfo): HandledSeasonItem => {
  const {
    cid,
    play_list_ui_type: playListUiType = PlayListUiType.PlayListTypeText,
    title = '',
    poster: {
      art_title_img: artTitleImg = '',
      horizontal_info: { pure_img_op_url: pureImgOpUrl = '', img_url: imgUrl = '' } = {},
    } = {},
    publish_year: publishYear = null,
    update_episode: updateEpisode = null,
    full_episode_count: fullEpisodeCount = null,
    detail_info: detailInfo = '',
    next_page_info: nextPageInfo = {
      data_key: '',
      page_context: '',
      has_next_page: true,
    },
  } = season;
  const tagLabelList: TagLabel[] = [];
  if (!!publishYear)
    tagLabelList.push({
      text: String(publishYear),
    });
  if (!!fullEpisodeCount)
    tagLabelList.push({
      text: allEpisode.replace('%@', `${fullEpisodeCount}`),
    });
  // 如果有值并且跟总集数不一致，才显示
  if (!!updateEpisode && fullEpisodeCount !== updateEpisode)
    tagLabelList.push({
      text: updateToEpisode.replace('%@', `${updateEpisode}`),
    });

  return {
    cid,
    seasonType: SeasonType.SeasonNormal,
    playListStyleKey: playListStyleType[playListUiType],
    groupList: [],
    defGroupIdx: 0,
    defPosterIdx: 0,
    isLoaded: false,
    isLoading: false,
    isError: false,
    artTitleImg,
    title,
    pureImgOpUrl: pureImgOpUrl || imgUrl,
    tagLabelList,
    initialRequestParams: {
      initialVal: [],
      nextPageInfo: {
        ...nextPageInfo,
        has_next_page: true,
      },
    },

    detailInfo,
  };
};

export const handledSeasonList = ({
  seasonList,
  autoPlayVideoData,
  playListData,
  relatedVideoData,
}: {
  seasonList: SeasonInfo[];
  autoPlayVideoData: AutoPlayVideoData;
  playListData: {
    initialVal: HandledVideoItemData[];
    nextPageInfo: NextPageInfo;
  } | null;
  relatedVideoData: {
    initialVal: HandledVideoItemData[];
    nextPageInfo: NextPageInfo;
  } | null;
}): {
  seasonListData: HandledSeasonItem[];
  defSeasonIdx: number;
  autoPlayVideoData: AutoPlayVideoData;
  updateInfo: string;
} => {
  const { cid, vid, vidParams } = autoPlayVideoData;
  let curSeasonInfo: HandledSeasonItem | null = null;
  let defEpisodeIdx = -1;
  let defRelatedIdx = -1;
  let defSeasonIdx = -1;
  const seasonListData: HandledSeasonItem[] = [];
  let autoPlayVideoDataFixRes = {
    ...autoPlayVideoData,
  };

  seasonList.forEach((item, idx) => {
    let res = handleDefSeasonItem(item);
    // 当前season的
    if (item.cid === cid) {
      curSeasonInfo = res;
      res = {
        ...res,
        title: res.title || episodeList,
      };
      if (!!playListData?.initialVal?.length) {
        defEpisodeIdx = idx;
        res = {
          ...res,
          initialRequestParams: {
            ...playListData,
          },
        };
      }
    }
    seasonListData.push(res);
  });
  if (!!relatedVideoData?.initialVal?.length && !!curSeasonInfo) {
    defRelatedIdx = seasonListData.length;
    seasonListData.push({
      ...(curSeasonInfo as HandledSeasonItem),
      title: relatedEpisodes,
      seasonType: SeasonType.SeasonRelatedvideo,
      initialRequestParams: {
        ...relatedVideoData,
      },
    });
  }
  if (defEpisodeIdx === -1 && defRelatedIdx === -1) {
    throw new Error('No episodes or related videos available');
  }
  // 根据历史记录或者自动播放的，设置默认选中的 season
  if ((!!vid || !!vidParams) && defEpisodeIdx !== -1) {
    defSeasonIdx = defEpisodeIdx;
  } else if ((!!vid || !!vidParams) && defRelatedIdx !== -1) {
    defSeasonIdx = defRelatedIdx;
  } else {
    // 没有历史记录或者自动播，或者历史记录和 剧集信息不匹配的，重新设置自动播放的剧集为 正片或花絮 第一集，优先取正片
    if (defEpisodeIdx !== -1) {
      // 没有历史记录或者自动播，选中正片
      defSeasonIdx = defEpisodeIdx;
      autoPlayVideoDataFixRes = {
        ...autoPlayVideoDataFixRes,
        vid: playListData?.initialVal?.[0]?.vid,
        videoPlayTime: playListData?.initialVal?.[0]?.skipHeadBegin || 15,
        isHistory: false,
        title: playListData?.initialVal?.[0]?.title || '',
      };
    } else if (defRelatedIdx !== -1) {
      // 没有历史记录或者自动播 并且没有 正片，选中花絮
      defSeasonIdx = defRelatedIdx;
      autoPlayVideoDataFixRes = {
        ...autoPlayVideoDataFixRes,
        vid: relatedVideoData?.initialVal?.[0]?.vid,
        videoPlayTime: playListData?.initialVal?.[0]?.skipHeadBegin || 15,
        isHistory: false,
        title: playListData?.initialVal?.[0]?.title || '',
      };
    } else {
      throw new Error('No history record or autoplay, and no episodes or related videos available');
    }
  }

  const { detailInfo } = seasonListData[defSeasonIdx];

  return {
    seasonListData,
    defSeasonIdx,
    autoPlayVideoData: autoPlayVideoDataFixRes,
    updateInfo: detailInfo,
  };
};

export const getOptionList = (autoPlayVideoData: AutoPlayVideoData): OptionListItem[] => {
  const { isHistory, title } = autoPlayVideoData;
  return !!isHistory
    ? [
        {
          text: `${containuePlay} ${title}`,
          type: OptionType.PlayBtn,
        },
        {
          text: episodeAndRelateVideo,
          type: OptionType.PlayListBtn,
        },
      ]
    : [
        {
          text: `${playNow}`,
          type: OptionType.PlayBtn,
        },
        {
          text: episodeAndRelateVideo,
          type: OptionType.PlayListBtn,
        },
      ];
};

export const handleDetailInfo = ({
  detailInfo,
  historyRecord,
  vidParams,
}: {
  detailInfo: PlayUrlResponse['data'];
  historyRecord: HistorySaveItem | null;
  vidParams?: string;
}): {
  artTitleImg: string;
  mainTitle: string;
  pureImgOpUrl: string;
  tagLabelList: TagLabel[];
  description: string;
  updateInfo: string;
  optionList: OptionListItem[];
  recommendData: HandledCoverItemData[];
  seasonListData: HandledSeasonItem[];
  autoPlayVideoData: AutoPlayVideoData;
  defSeasonIdx: number;
} => {
  if (!detailInfo) throw new Error('Detail information not available');
  // 解构数据
  const {
    recommend_list: recommendList,
    play_list_info: playListInfo,
    related_video_info: relatedVideoInfo,
    video_data: videoData,
  } = detailInfo;
  if (!playListInfo?.play_list_info?.length && !relatedVideoInfo?.play_list_info?.length)
    throw new Error('Playlist information not available');
  const recommendData = handleCoverList(recommendList?.recommend_list || []);
  let playListData = null;
  let relatedVideoData = null;

  if (!!playListInfo?.play_list_info?.length) {
    playListData = {
      initialVal: handleVideoList(playListInfo?.play_list_info || []),
      nextPageInfo: {
        ...playListInfo?.next_page_info,
        has_next_page: true,
      },
    };
  }

  if (!!relatedVideoInfo?.play_list_info?.length) {
    relatedVideoData = {
      initialVal: handleVideoList(relatedVideoInfo?.play_list_info || []),
      nextPageInfo: {
        ...relatedVideoInfo?.next_page_info,
        has_next_page: true,
      },
    };
  }

  const {
    cid = '',
    poster: {
      art_title_img: artTitleImg = '',
      main_title: mainTitle = '',
      description = '',
      tag_label_list: tagLabelList = [],
      horizontal_info: { pure_img_op_url: pureImgOpUrl = '', img_url: imgUrl = '' } = {},
    },
    season_list: seasonList = [],
  } = videoData;

  const { seasonListData, defSeasonIdx, autoPlayVideoData, updateInfo } = handledSeasonList({
    seasonList,
    autoPlayVideoData: {
      cid,
      vid: historyRecord?.vid,
      vidParams,
      videoPlayTime: historyRecord?.videoPlayTime || 15,
      isHistory: !!historyRecord?.vid,
      title: '',
    },
    playListData,
    relatedVideoData,
  });

  const optionList: OptionListItem[] = getOptionList(autoPlayVideoData);
  return {
    artTitleImg,
    mainTitle,
    pureImgOpUrl: imgUrl || pureImgOpUrl,
    tagLabelList,
    description,
    updateInfo,
    optionList,
    recommendData,
    autoPlayVideoData,
    defSeasonIdx,
    seasonListData,
  };
};

// seriesListPage分组方法
export const createVideoGroups = ({
  videoList,
  isRelatedVideo = false,
  autoPlayVideoData,
}: {
  videoList: HandledVideoItemData[];
  isRelatedVideo: boolean;
  autoPlayVideoData?: AutoPlayVideoData;
}): {
  groupList: GroupListItem[];
  defGroupIdx: number;
  defPosterIdx: number;
  autoPlayVideoData: AutoPlayVideoData | null;
  nextVidInfo: NextVidInfoItem;
} => {
  let vid = '';
  let vidParams = '';
  let videoPlayTime = 0;
  let autoPlayVideoDataFix = null;
  if (!!autoPlayVideoData) {
    vid = autoPlayVideoData.vid || '';
    vidParams = autoPlayVideoData.vidParams || '';
    videoPlayTime = autoPlayVideoData.videoPlayTime || 0;
    autoPlayVideoDataFix = {
      ...autoPlayVideoData,
    };
  }

  const result = [];
  const nextVidInfo: NextVidInfoItem = {};
  let currentGroup = [];
  let count = 0; // 记录当前组中有 episodeId 的元素个数
  let defGroupIdx = 0;
  let defPosterIdx = 0;
  let isHaveDefVideo = false;
  let isHaveParamsVideo = false;

  for (let i = 0; i < videoList.length; i++) {
    let curVideo = videoList[i];
    nextVidInfo[curVideo?.vid as string] = {
      nextVid: videoList[i + 1]?.vid || '',
      type: isRelatedVideo ? VideoType.SHORT : VideoType.LONG,
    };
    const { episodeId, vid: curVid } = curVideo;
    const isDefVideo = curVid === vid;
    const isParamsVideo = curVid === vidParams;

    // 历史记录的视频
    if (isDefVideo && autoPlayVideoData?.isHistory) {
      // 历史记录添加上次播放的进度条时间点
      curVideo = {
        ...videoList[i],
        videoPlayTime,
      };
    }
    // 只计算有 episodeId 的元素
    // 相关视频不计算
    if (!!episodeId || isRelatedVideo) count += 1;
    currentGroup.push(curVideo);

    // 记录默认视频的位置
    if (isParamsVideo) {
      isHaveParamsVideo = true;
      defGroupIdx = result.length;
      defPosterIdx = currentGroup.length - 1;
      if (autoPlayVideoDataFix) {
        autoPlayVideoDataFix = {
          ...autoPlayVideoDataFix,
          title: videoList[i].title,
          videoPlayTime: vid === vidParams ? videoPlayTime : 0,
          isHistory: vid === vidParams,
        };
      }
    } else if (isDefVideo && !isHaveParamsVideo) {
      isHaveDefVideo = true;
      defGroupIdx = result.length;
      defPosterIdx = currentGroup.length - 1;
      if (autoPlayVideoDataFix) {
        autoPlayVideoDataFix = {
          ...autoPlayVideoDataFix,
          title: videoList[i].title,
        };
      }
    }

    // 当前组已满 20 个或遍历到最后一个元素
    if (count === GROUP_SIZE || i === videoList.length - 1) {
      // 只有当前组有元素时才添加
      if (currentGroup.length > 0) {
        const firstVideo = currentGroup[0];
        const lastVideo = currentGroup[currentGroup.length - 1];
        // 默认是更多，相关视频是全部
        let defaultTitle = more;
        // 只有一部剧集
        if (currentGroup.length === 1) {
          defaultTitle = episodeNum.replace('%@', `${firstVideo.episodeId}`);
        } else if (!!firstVideo.episodeId && !!lastVideo.episodeId) {
          // 有多部剧集并且前后都有 episodeId的
          defaultTitle = episodeNumToNum
            .replace('%@', `${firstVideo.episodeId}`)
            .replace('%@', `${lastVideo.episodeId}`);
        }
        // 没有episode信息的区间 用 more 表示，并且正常切换更新groupIdx

        // 相关视频 全部都使用 more 表示，分组正常分组，
        // 切换时 groupIdx更改也正常更改，但是页面展示以及切换时强制聚焦在第一位，但不设置
        result.push({
          videoList: currentGroup,
          title: isRelatedVideo ? allText : defaultTitle,
        });
        currentGroup = [];
        count = 0;
      }
    }
  }

  if (!!autoPlayVideoData && videoList.length > 0) {
    if (!isHaveDefVideo && !isHaveParamsVideo) {
      // 如果没有找到历史记录的 或者0位置的视频，使用第一个视频
      autoPlayVideoDataFix = {
        cid: autoPlayVideoDataFix?.cid || videoList[0].cid,
        vid: videoList[0].vid,
        videoPlayTime: 0,
        isHistory: false,
        title: videoList[0].title,
      };
    }
  }

  return {
    autoPlayVideoData: autoPlayVideoDataFix,
    groupList: result,
    defGroupIdx,
    defPosterIdx,
    nextVidInfo,
  };
};

// 更新数组中的指定项
export const updateArrayItem = <T>(array: T[], index: number, updater: (item: T) => T): T[] => {
  if (index < 0 || index >= array.length) return array;
  return array.map((item, i) => (i === index ? updater(item) : item));
};

export const getIds = (cid: string, vid: string) => {
  return {
    cid: CIDCheck.test(cid) ? cid : '',
    vid: VIDCheck.test(vid) ? vid : '',
  };
};

export const getAutoPlayCidAndVid = (autoPlayVideoData: AutoPlayVideoData) => {
  const {
    cid: autoPlayCid,
    vid: autoPlayVid,
    vidParams: autoPlayVidParams,
    isHistory: autoPlayIsHistory,
  } = autoPlayVideoData || {};
  return {
    autoPlayCid,
    autoPlayVid: autoPlayIsHistory ? autoPlayVid : autoPlayVidParams || autoPlayVid,
  };
};
